module.exports = __webpack_public_path__ + "static/img/healer3.5a09c9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/scoiatael/healer3.png
// module id = xt9B
// module chunks = 0